"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var roles = window.cccisd.appDefs.pawn.roles;
var UrlPicker = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function UrlPicker() {
    var _this;
    _classCallCheck(this, UrlPicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UrlPicker, [].concat(args));
    _defineProperty(_this, "shouldShowRequirePassword", function () {
      // only allow require password if managed participants and selected role takes a user
      var roleHasUser = false;
      if (_this.props.role) {
        var selectedUser = roles.find(function (role) {
          return role.handle === _this.props.role;
        });
        if (selectedUser) {
          roleHasUser = selectedUser.isFortressUser;
        }
      }
      return _this.props.fields.respondentConfig.value === 'managed' && roleHasUser;
    });
    return _this;
  }
  _inherits(UrlPicker, _React$Component);
  return _createClass(UrlPicker, [{
    key: "render",
    value: function render() {
      var _this$props$fields = this.props.fields,
        requirePass = _this$props$fields.requirePass,
        useEndpoint = _this$props$fields.useEndpoint,
        endpoint = _this$props$fields.endpoint,
        hash = _this$props$fields.hash;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: endpoint
      }, useEndpoint.value ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "input-group"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-group-text"
      }, Boilerplate.url('/survey/')), /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "text",
        style: {
          maxWidth: '10em'
        },
        className: "form-control",
        autoFocus: true
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(endpoint)))) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "input-group"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-group-text"
      }, Boilerplate.url('/d/' + hash.value)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check mb-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(useEndpoint))), " Use custom URL")), this.shouldShowRequirePassword() && /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(requirePass))), ' ', "Require password")));
    }
  }]);
}(_react["default"].Component);
_defineProperty(UrlPicker, "propTypes", {
  fields: _propTypes["default"].object
});